import { GetterTree } from "vuex";
import { OnlineUsersState } from "../types/OnlineUsersState";
import { RootState } from "@service/store/types/RootState";

const getters: GetterTree<OnlineUsersState, RootState> = {
    counter: (state) => (id: string) => {
        return state.counters[id] ?? undefined
    },
    activities: (state) => {
        return state.activities;
    },
    counts: (state) => (ids: string[]) => {
        let result: Record<string, number> = {};
        for (const [key, value] of Object.entries(state.counters)) {
            if (ids.includes(key)) {
                result[key] = value && value.count ? value.count : 0;
            }
        }
        return result;
    }
};

export {getters}